module.exports = __webpack_public_path__ + "img/Terraform.7ad7a3e8.png";